module.exports = __webpack_public_path__ + "static/media/inquiries-icon.1f44e83c.svg";